import React from "react";

const Footer = () => {
  return (
   
    <footer className="py-lg-8 py-5 footer-section">
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-4 col-12">
           
            <div className="d-flex flex-column gap-4">
              <div>
               
              </div>
              <div>
                <p className="mb-0 txet-gray-500">Connecting founders and marketers with battle-hardened mentors that genuinely enjoy helping people.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-6">
            <div className="d-flex flex-column gap-2">
            
              <h5 className="fw-bold text-white text-uppercase mb-0">bsk boutique</h5>
              <ul className="footer-collection">
                <li><a href="#" className="nav-link">About</a></li>
                <li><a href="#" className="nav-link">Click to shopping</a></li>
                <li><a href="#" className="nav-link">Blog</a></li>
                <li><a href="#" className="nav-link">Contact Us</a></li>
                <li><a href="#" className="nav-link">FAQ</a></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-6">
            <div className="d-flex flex-column gap-2">
             
              <h5 className="fw-bold text-white text-uppercase mb-0">Support</h5>
              <ul className="footer-collection">
              <li><a href="#" className="nav-link">Track Order</a></li>
              <li><a href="#" className="nav-link">Return Policy</a></li>
                <li><a href="#" className="nav-link">Terms & Conditions</a></li>
                <li><a href="#" className="nav-link">Privacy Policy</a></li>
                <li><a href="#" className="nav-link">Size Chart</a></li>
              </ul>
            </div>
          </div>
         
          <div className="col-lg-2 col-md-3 col-6">
            <div className="d-flex flex-column gap-2">
            
              <h5 className="fw-bold text-white text-uppercase mb-0">Follow us</h5>
              <ul className="footer-collection">
                <li><a href="#" className="nav-link">FAQ</a></li>
                <li><a href="#" className="nav-link">Contact</a></li>
                <li><a href="#" className="nav-link">Help centre</a></li>
                <li><a href="#" className="nav-link">Join Community</a></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-6">
            <div className="d-flex flex-column gap-2">
           
              <h5 className="fw-bold text-white text-uppercase mb-0">payment</h5>
              <ul className="footer-collection">
                <li><a href="#" className="nav-link">About</a></li>
                <li><a href="#" className="nav-link">Partner Program</a></li>
                <li><a href="#" className="nav-link">Privacy Policy</a></li>
                <li><a href="#" className="nav-link">Meet the Team</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row mt-lg-7 mt-5">
        
          <div className="col-lg-6 offset-lg-3 col-12 text-white">
            <span className="d-flex justify-content-center">
              ©
              <span id="copyright2" className="me-2">
                {/* <script>
                  document.getElementById("copyright2").appendChild(document.createTextNode(new Date().getFullYear()));
                </script> */}
              </span>
             BSK Boutique. All Rights Reserved.
            </span>
          </div>
        </div>
      </div>
    </footer>
    
  


  

  
  );
};

export default Footer;
